import * as actions from "../actions/agents";
import * as chatActions from "../actions/chat";

const INITIAL_STATE = {
  error: null,
  agents: [],
  activeMedia: null,
  activeSupportingContent: null,
  agent: null,
  agentChatSessions: null,
  agentSupportingContent: [],
  agentMedia: [],
  savedAgent: null,
  saving: false,
  savingMedia: false,
};

const agents = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actions.RETRIEVED_AGENTS:
      return {
        ...state,
        agents: action.agents,
      };
    case actions.RETRIEVED_AGENT:
      return {
        ...state,
        agent: action.agent,
      };
    case actions.RETRIEVED_AGENT_CHAT_SESSIONS:
      return {
        ...state,
        agentChatSessions: action.agentChatSessions,
      };
    case actions.RETRIEVED_AGENT_SUPPORTING_CONTENT:
      return {
        ...state,
        agentSupportingContent: action.agentSupportingContent,
      };
    case actions.RETRIEVED_AGENT_MEDIA:
      return {
        ...state,
        agentMedia: action.agentMedia,
      };
    case actions.SAVING_AGENT:
      return {
        ...state,
        saving: action.saving,
      };
    case actions.SAVING_MEDIA:
      return {
        ...state,
        savingMedia: action.saving,
      };
    case actions.SAVED_AGENT:
      return {
        ...state,
        saving: false,
        savedAgent: action.savedAgent,
      };
    case actions.CLEAR_SAVED_AGENT:
      return {
        ...state,
        savedAgent: null,
      };
    case actions.RETRIEVED_MEDIA:
      return {
        ...state,
        activeMedia: action.media,
      };
    case actions.RETRIEVED_SUPPORTING_CONTENT:
      return {
        ...state,
        activeSupportingContent: action.supportingContent,
      };
    case actions.ADD_CHAT_SESSION:
      const existing_chat_sessions = state.agent?.chat_sessions
        ? [...state.agent.chat_sessions]
        : [];
      return {
        ...state,
        agent: {
          ...state.agent,
          chat_sessions: [...existing_chat_sessions, action.chatSession],
        },
      };
    case actions.DELETE_CHAT_SESSION:
      const agentChatSessions = [...state.agentChatSessions];
      const newAgentChatSessions = agentChatSessions.filter(
        (cs) => cs.public_id !== action.chatSessionID
      );

      return {
        ...state,
        agentChatSessions: newAgentChatSessions,
      };
    case actions.DELETE_SUPPORTING_CONTENT:
      return {
        ...state,
        agent: {
          ...state.agent,
          supporting_content: state.agent.supporting_content.filter(
            (sc) => sc.public_id !== action.supportingContentID
          ),
        },
      };
    case actions.DELETE_MEDIA:
      const newAgentMedia = state.agentMedia.filter(
        (m) => m.public_id !== action.mediaID
      );
      return {
        ...state,
        agentMedia: newAgentMedia,
      };

    case chatActions.SET_ACTIVE_CHAT_SESSION: {
      if (!state?.agentChatSessions) return state;

      const agentChatSessions = [...state.agentChatSessions];
      // Update the chat session data in the agent chat sessions
      for (let i = 0; i < agentChatSessions.length; i++) {
        if (agentChatSessions[i].public_id === action.chatSession.public_id) {
          agentChatSessions[i].status = action.chatSession.status;
          break;
        }
      }
      return {
        ...state,
        agentChatSessions: agentChatSessions,
      };
    }

    default:
      return state;
  }
};

export default agents;
